import { LoadingSpinner } from '@web_opxp/components';
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import ENV from './base/env';
import { Cancel, Error, Progress, Success } from './checkout';
import Checkout from './CheckoutWrapper';
import { NavigationBlockProvider } from './medBanner';

const Subscribe = lazy(() => import('./SubscribeWrapper'));
// this lazy import makes build to fail because of chaos in css imports
// we need to find out how to fix it before we can actually import it in a lazy mode
//const Checkout = lazy(() => import('./CheckoutWrapper'));
const Manage = lazy(() => import('./ManageWrapper'));
const Orders = lazy(() => import('./OrdersWrapper'));
const DirectSubscribe = lazy(() => import('./directSubscribe'));

export default function Root() {
  return (
    <NavigationBlockProvider>
      <Suspense fallback={<LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />}>
        <Routes>
          <Route path="/checkout" Component={Checkout}>
            <Route path="success" Component={Success} />
            <Route path="cancel" Component={Cancel} />
            <Route path="error" Component={Error} />
            <Route path=":planId" Component={Progress} />
          </Route>
          <Route path="/manage" Component={Manage} />
          <Route path="/orders" Component={Orders} />
          <Route path="/direct/:productId" Component={DirectSubscribe} />
          <Route path="/cb" Component={Subscribe} />
          <Route path="/" Component={Subscribe} />
        </Routes>
      </Suspense>
    </NavigationBlockProvider>
  );
}
